// src/components/RefundPolicy.js
import React from 'react';
import PolicyPage from './PolicyPage';

function RefundPolicy() {
  return (
    <PolicyPage title="Refund Policy" lastUpdated="[Date]">
      <h2>1. Eligibility for Refund</h2>
      <ul>
        <li>An order is cancelled before pickup for prepaid bookings.</li>
        <li>The service is not delivered due to operational reasons from our side.</li>
        <li>There is proven loss or damage to garments caused solely by IronBhai's negligence.</li>
      </ul>
      <h2>2. Non-Refundable Cases</h2>
      <ul>
        <li>The garments have already been processed.</li>
        <li>There is damage due to pre-existing defects, color bleeding, or poor fabric quality.</li>
        <li>The order was placed under a non-refundable promotional offer.</li>
      </ul>
      <h2>3. Refund Process</h2>
      <ul>
        <li>Refunds (if approved) will be issued to the original payment method only.</li>
        <li>Processing time: 7-10 business days from approval date.</li>
      </ul>
      <h2>4. Partial Refunds</h2>
      <p>In case of partial service issues, refunds will be calculated proportionately based on the affected item's service charges.</p>
      <h2>5. Contact for Refund Requests</h2>
      <p className="contact">📧 Email: <a href="mailto:support@ironbhai.com">support@ironbhai.com</a><br />
      📞 Phone: +91 8688206969</p>
    </PolicyPage>
  );
}

export default RefundPolicy;
